import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./SchemaPropertyPattern.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                          */
//#region src/schema/SchemaPropertyPattern.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-e8f7b07b"]]);
//#endregion
export { n as default };

//# sourceMappingURL=SchemaPropertyPattern.vue.js.map